import { Box, Flex, Text, Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableContainer,
  Tooltip,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
 } from "@chakra-ui/react";
import { DetalhePagamento } from "../../hooks/pagamento/usePedido";
import { formatBRL, isRs } from "../../utils/currency";
import { BilheteStatusCode } from "../../utils/interfaces";
import { shouldHideFeeDetails, useShouldShowProvider } from "../../libs/auth";
import { formatProvider } from "../../utils/provider";

interface Props {
  detalhe: DetalhePagamento;
  contexto: 'ida' | 'volta';
  isDetail?: boolean;
}

export function DetalhesBilhete({ detalhe, contexto, isDetail=false }: Props){
  const hideFeeDetails = shouldHideFeeDetails();
  const showProvider = useShouldShowProvider();

  const {detalhes, pagamento} = detalhe
  const bilhetes = Array.isArray(detalhe.bilhetes) ? detalhe.bilhetes : [];
  const formatTransacao = (value?: string) => {
    if (!value) {
      return "";
    }
    return value.length > 50 ? `${value.slice(0, 50)}...` : value;
  };

  return (
    <Flex width={{sm: 'full', xl: '40rem'}} flexDir={'column'} >
          <Box bg={"#f4f4f4"} px={2}>
          <Text as={'h4'} textTransform={'uppercase'} fontWeight={'bold'}>Detalhes da viagem de {contexto}
          </Text>
            {showProvider && (
            <Flex justifyContent={'space-between'} fontWeight={'700'} borderBottom={'1px solid #ddd'}>
              <Text color={'#3f3f3f'} fontSize={'sm'}>Provedor</Text>
              <Text color={'#3f3f3f'} fontSize={'sm'}>{formatProvider(bilhetes[0]?.adaptador, bilhetes[0]?.provedorWebviagem)}</Text>
            </Flex>
            )}
            <Flex justifyContent={'space-between'} fontWeight={'700'} borderBottom={'1px solid #ddd'}>
              <Text color={'#3f3f3f'} fontSize={'sm'}>Empresa</Text>
              <Text color={'#3f3f3f'} fontSize={'sm'}>{detalhes.empresa}</Text>
            </Flex>
            <Flex justifyContent={'space-between'} fontWeight={'700'} borderBottom={'1px solid #ddd'}>
              <Text color={'#3f3f3f'} fontSize={'sm'}>Origem</Text>
              <Text color={'#3f3f3f'} fontSize={'sm'}>{detalhes.origem}</Text>
            </Flex>
            {detalhes.endereco_embarque && (
              <Flex justifyContent={'space-between'} fontWeight={'700'} borderBottom={'1px solid #ddd'} gap={4}>
                <Text color={'#3f3f3f'} fontSize={'sm'} whiteSpace={'nowrap'}>Endereço de embarque</Text>
                <Text color={'#3f3f3f'} fontSize={'sm'} textAlign={'right'}>{detalhes.endereco_embarque}</Text>
              </Flex>
            )}
            <Flex justifyContent={'space-between'} fontWeight={'700'} borderBottom={'1px solid #ddd'}>
              <Text color={'#3f3f3f'} fontSize={'sm'}>Destino</Text>
              <Text color={'#3f3f3f'} fontSize={'sm'}>{detalhes.destino}</Text>
            </Flex>
            <Flex justifyContent={'space-between'} fontWeight={'700'} borderBottom={'1px solid #ddd'}>
              <Text color={'#3f3f3f'} fontSize={'sm'}>Classe</Text>
              <Text color={'#3f3f3f'} fontSize={'sm'}>{detalhes.classe}</Text>
            </Flex>
            <Flex justifyContent={'space-between'} fontWeight={'700'} borderBottom={'1px solid #ddd'}>
              <Text color={'#3f3f3f'} fontSize={'sm'}>Saída</Text>
              <Text color={'#3f3f3f'} fontSize={'sm'}>{detalhes.saida}</Text>
            </Flex>
            <Flex justifyContent={'space-between'} fontWeight={'700'} borderBottom={'1px solid #ddd'}>
              <Text color={'#3f3f3f'} fontSize={'sm'}>Chegada Prevista</Text>
              <Text color={'#3f3f3f'} fontSize={'sm'}>{detalhes.chegada}</Text>
            </Flex>
          </Box>
          {!hideFeeDetails && (
          <Box bg={"#f4f4f4"} px={2}>
            <Text as={'h4'} textTransform={'uppercase'} fontWeight={'bold'}>Taxas por Bilhete</Text>
            <Flex justifyContent={'space-between'} fontWeight={'700'} borderBottom={'1px solid #ddd'}>
              <Text color={'#3f3f3f'} fontSize={'sm'}>Preço da Passagem</Text>
              <Text color={'#3f3f3f'} fontSize={'sm'}>{formatBRL(pagamento.valor_bilhete)}</Text>
            </Flex>
            <Flex justifyContent={'space-between'} fontWeight={'700'} borderBottom={'1px solid #ddd'}>
              <Text color={'#3f3f3f'} fontSize={'sm'}>Viagem premiada</Text>
              <Text color={'#3f3f3f'} fontSize={'sm'}>{formatBRL(pagamento.viagem_premiada ?? pagamento.valor_seguro)}</Text>
            </Flex>
            <Flex justifyContent={'space-between'} fontWeight={'700'} borderBottom={'1px solid #ddd'}>
              <Text color={'#3f3f3f'} fontSize={'sm'}>Conv. Parceiro</Text>
              <Text color={'#3f3f3f'} fontSize={'sm'}>{formatBRL(pagamento.taxa_agencia)}</Text>
            </Flex>
            <Flex justifyContent={'space-between'} fontWeight={'700'} borderBottom={'1px solid #ddd'}>
              <Text color={'#3f3f3f'} fontSize={'sm'}>Conveniência</Text>
              <Text color={'#3f3f3f'} fontSize={'sm'}>{formatBRL(pagamento.taxa_sistema)}</Text>
            </Flex>
            <Flex justifyContent={'space-between'} fontWeight={'700'} borderBottom={'1px solid #ddd'}>
              <Text color={'#3f3f3f'} fontSize={'sm'}>TOTAL</Text>
              <Text color={'#3f3f3f'} fontSize={'sm'}>{formatBRL(pagamento.valor_total)}</Text>
            </Flex>
          </Box>
          )}
          {detalhes.alerta !== null && (
          <Box my={2}>
              <Alert status='error'>
                <AlertIcon />
                <AlertTitle>{detalhes.alerta.title}</AlertTitle>
                <AlertDescription>{detalhes.alerta.mensagem}</AlertDescription>
              </Alert>
          </Box>
          )}
          {isRs(detalhes.origem, detalhes.destino) && (
            <Box my={2}>
              <Alert status='error'>
                <AlertIcon />
                <AlertTitle>Atenção</AlertTitle>
                <AlertDescription>
                Devido a essa viagem ser uma viagem intermunicipal dentro do estado do Rio Grande do Sul, é obrigatório a impressão do BPE, bilhete de passagem eletrônico
                </AlertDescription>
              </Alert>
          </Box>
          )}
          <Box py={4} bg={"#f4f4f4"} px={2}>
            <Text fontWeight={'bold'} color={'#4c4c4c'}>ASSENTOS ESCOLHIDOS</Text>
              <TableContainer>
              <Table variant='simple' textTransform={'uppercase'} >
              <Thead>
                  <Tr>
                    <Th bg={'#cccccc'} p={1}>Poltrona</Th>
                    <Th bg={'#cccccc'} p={1}>Nome</Th>
                    <Th bg={'#cccccc'} p={1}>Documento</Th>
                    <Th bg={'#cccccc'} p={1}>Telefone</Th>
                    <Th bg={'#cccccc'} p={1}>Expira em</Th>
                    <Th bg={'#cccccc'} p={1}>Valor</Th>
                    {isDetail && (
                        <>
                        <Th bg={'#cccccc'} p={1}>Transação</Th>
                        <Th bg={'#cccccc'} p={1}>Localizador</Th>
                        <Th bg={'#cccccc'} p={1}>NºPedido</Th>
                        <Th bg={'#cccccc'} p={1}>Serviço</Th>
                        </>
                      )}
                  </Tr>
                </Thead>
                <Tbody color={'#575757'}>
                  {bilhetes.map(bilhete => (
                    <Tr p={'2px 5px'} key={bilhete.id}>
                      <Td color={bilhete.is_expired || bilhete.status === BilheteStatusCode.Cancelado ? 'red.500' : '#575757'} fontSize={'sm'} border={'1px solid #cccccc'} textAlign={'center'} px={'2px'} py={'5px'}>{bilhete.assento}</Td>
                      <Td color={bilhete.is_expired || bilhete.status === BilheteStatusCode.Cancelado ? 'red.500' : '#575757'} fontSize={'sm'} border={'1px solid #cccccc'} textAlign={'center'} px={'2px'} py={'5px'}>{bilhete.passageiro?.nome}</Td>
                      <Td color={bilhete.is_expired || bilhete.status === BilheteStatusCode.Cancelado ? 'red.500' : '#575757'} fontSize={'sm'} border={'1px solid #cccccc'} textAlign={'center'} px={'2px'} py={'5px'}>{bilhete.passageiro?.documento}</Td>
                      <Td color={bilhete.is_expired || bilhete.status === BilheteStatusCode.Cancelado ? 'red.500' : '#575757'} fontSize={'sm'} border={'1px solid #cccccc'} textAlign={'center'} px={'2px'} py={'5px'}>{bilhete.passageiro?.telefone}</Td>
                      <Td color={bilhete.is_expired || bilhete.status === BilheteStatusCode.Cancelado ? 'red.500' : '#575757'} fontSize={'sm'} border={'1px solid #cccccc'} textAlign={'center'} px={'2px'} py={'5px'}>{bilhete.expires_at}</Td>
                      <Td color={bilhete.is_expired || bilhete.status === BilheteStatusCode.Cancelado ? 'red.500' : '#575757'} fontSize={'sm'} border={'1px solid #cccccc'} textAlign={'center'} px={'2px'} py={'5px'}>{formatBRL(bilhete.valor_total)}</Td>
                      {isDetail && (
                        <>
                        <Td fontSize={'sm'} border={'1px solid #cccccc'} textAlign={'center'} px={'2px'} py={'5px'}>
                          <Tooltip label={bilhete.id_transacao} fontSize="lg">
                            {formatTransacao(bilhete.id_transacao)}
                          </Tooltip>
                        </Td>
                        <Td fontSize={'sm'} border={'1px solid #cccccc'} textAlign={'center'} px={'2px'} py={'5px'}>{bilhete.localizador}</Td>
                        <Td fontSize={'sm'} border={'1px solid #cccccc'} textAlign={'center'} px={'2px'} py={'5px'}>{bilhete.numero_pedido}</Td>
                        <Td fontSize={'sm'} border={'1px solid #cccccc'} textAlign={'center'} px={'2px'} py={'5px'}>{bilhete.servico?.slice(10,1 )}</Td>
                        </>
                      )}
                    </Tr>
                  ))}
                </Tbody>
                <Tfoot>
                  <Tr border={'1px solid #cccccc'}>
                    <Th border={'1px solid #cccccc'} textAlign={'center'} px={'2px'} py={'5px'} color={'red'} colSpan={5}>TOTAL</Th>
                    <Th border={'1px solid #cccccc'} textAlign={'center'} px={'2px'} py={'5px'} color={'red'}>{formatBRL(bilhetes.reduce(
                      (accumulator, currentValue) => accumulator + currentValue.valor_total,
                      0))}</Th>
                  </Tr>
                </Tfoot>
              </Table>
              </TableContainer>
          </Box>
        </Flex>
  )
}
